<template>
  <div class="min-h-screen bg-grid-gray">
    <div class="text-center py-13">
      <router-link :to="{ name: 'Homepage' }">
        <img src="../assets/img/logo-dark.svg" alt="Fleetbeacon Logo" class="h-10 mx-auto">
      </router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'AuthLayout'
  }
</script>